import * as React from 'react';
import { useNavigate } from "react-router-dom";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';

const Item = styled(Button)(({ theme }) => ({
    width: '20vw',
    height: '16vmin',
    fontSize: '4vmin'
}));

const BoxItem = styled(Paper)(({ theme }) => ({
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundImage: 'linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))',
}));

export default function GisHome() {
    const navigate = useNavigate();

    const linkHandler = (to) => {
        navigate(to)
    }

    return (
        <BoxItem>
            <Stack spacing={{ xs: 1, sm: 2 }} direction="row" flexWrap="wrap"
                justifyContent="center"
                alignItems="center"
                sx={{ width: '100%', height: '100%' }}
            >
                <Item variant='contained' onClick={() => linkHandler('/gis/gisView')}>GIS</Item>
                <Item variant='contained' onClick={() => linkHandler('/gis/gisView2')}>GIS2</Item>

            </Stack>
            <Typography sx={{position:'absolute', left:0, top:0, m:1}}>* 월컨트롤러(10400x1800), GIS(3293x1800)</Typography>
        </BoxItem>
    );
}